export default __webpack_public_path__ + "static/media/IMG_6705.f1bcbc66.jpg";